var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/Autocomplete/Autocomplete.tsx",
  _this = this;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import { Input } from '@wds/input';
import { InputGroup, InputGroupAddon } from '@wds/input-group';
import { Menu } from '@wds/menu';
import { ProgressCircle } from '@wds/progress-circle';
import { IconSearch, IconWarning } from '@wds/icons';
import { WebAssetsThemeWrapper } from '../../theme';
var UNSELECTED_ITEM_INDEX = -1;
var Autocomplete = function Autocomplete(props) {
  return /*#__PURE__*/React.createElement(WebAssetsThemeWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement(AutocompleteContent, Object.assign({}, props, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 5
    }
  })));
};
var AutocompleteContent = function AutocompleteContent(_ref) {
  var data = _ref.data,
    onTextChanged = _ref.onTextChanged,
    _ref$onItemSelected = _ref.onItemSelected,
    onItemSelected = _ref$onItemSelected === void 0 ? function () {} : _ref$onItemSelected,
    text = _ref.text,
    placeholder = _ref.placeholder,
    _ref$renderItem = _ref.renderItem,
    renderItem = _ref$renderItem === void 0 ? function (item) {
      return item.text;
    } : _ref$renderItem,
    _ref$onSubmit = _ref.onSubmit,
    onSubmit = _ref$onSubmit === void 0 ? function () {} : _ref$onSubmit,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? /*#__PURE__*/React.createElement(IconSearch, {
      title: "Search",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 28,
        columnNumber: 10
      }
    }) : _ref$icon,
    _ref$hasError = _ref.hasError,
    hasError = _ref$hasError === void 0 ? false : _ref$hasError;
  var _useState = useState(UNSELECTED_ITEM_INDEX),
    _useState2 = _slicedToArray(_useState, 2),
    currentIndex = _useState2[0],
    setCurrentIndex = _useState2[1];
  var handleTextChange = function handleTextChange(e) {
    onTextChanged(e.target.value);
  };
  var handleItemSelected = function handleItemSelected(e) {
    var index = Number(e.currentTarget.getAttribute('data-index'));
    if (typeof index === 'number') {
      var item = data[index];
      onItemSelected(item);
    }
  };
  var hasIcon = typeof icon !== 'undefined';
  var handleKeyDown = function handleKeyDown(e) {
    var _ref2 = e.target,
      value = _ref2.value;
    if (e.key === 'Enter' && currentIndex > -1) {
      onItemSelected(data[currentIndex]);
    } else if (e.key === 'Enter' && value) {
      onSubmit(value);
    } else if (e.key === 'Escape') {
      onTextChanged('');
    } else if (e.key === 'ArrowDown' && currentIndex < data.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else if (e.key === 'ArrowUp' && currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    } else if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') {
      setCurrentIndex(-1);
    }
  };
  var renderInput = function renderInput() {
    var color = hasError ? 'warning' : undefined;
    return /*#__PURE__*/React.createElement(InputGroup, {
      "data-testid": "Autocomplete",
      stretched: true,
      color: color,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 67,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(Input, {
      id: "Autocomplete",
      "data-testid": "Autocomplete__Input",
      value: text,
      onChange: handleTextChange,
      placeholder: placeholder,
      onKeyDown: handleKeyDown,
      stretched: true,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 68,
        columnNumber: 9
      }
    }), isLoading ? /*#__PURE__*/React.createElement(InputGroupAddon, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 79,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(ProgressCircle, {
      continuous: true,
      valueText: "Loading...",
      size: "xs",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 80,
        columnNumber: 13
      }
    })) :
    // eslint-disable-next-line no-nested-ternary
    hasError ? /*#__PURE__*/React.createElement(InputGroupAddon, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 84,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(IconWarning, {
      title: "Warning",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 85,
        columnNumber: 13
      }
    })) : hasIcon ? /*#__PURE__*/React.createElement(InputGroupAddon, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 88,
        columnNumber: 11
      }
    }, icon) : null);
  };
  return /*#__PURE__*/React.createElement(Menu, {
    "data-testid": "Autocomplete__Menu",
    dense: true,
    noRules: true,
    show: data.length > 0 && !!text,
    menuTrigger: renderInput(),
    stretched: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 95,
      columnNumber: 5
    }
  }, data.map(function (item, idx) {
    return /*#__PURE__*/React.createElement(Menu.Item, {
      "data-testid": "Autocomplete__MenuItem",
      key: item.id,
      onClick: handleItemSelected,
      isFocused: currentIndex === idx,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 104,
        columnNumber: 9
      }
    }, renderItem(item));
  }));
};
Autocomplete.defaultProps = {};
export default Autocomplete;
//# sourceMappingURL=Autocomplete.js.map